import { useContext, useEffect, useState } from 'react';

import axios from 'axios';

import { AppContext } from '~/contexts/AppContext';

import TopicCardComponent from '~/components/TopicCard';

import { TopicCard } from '~/types';
import TypingText from '../components/TypingText';
import StyledContentPanel from '~/components/StyledContentPanel';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import MatomoTracker from '~/util/matomo/MatomoTracker';

export default () => {
    const [topics, setTopics] = useState<TopicCard[] | null>(null);
    const { apiUrl, setTopicData, setGlassPanelColor, setGlassPanelBackdropFilter, setLoading } = useContext(AppContext)!;

    const history = useHistory();
    const { t } = useTranslation();

    const loadTopics = async () => {
        setLoading(true);

        const res = await axios.get(`${apiUrl}/channel/now/topics`);

        // analytics call
        MatomoTracker.trackPageView({
            documentTitle: 'Начало - Казва БГ',
            href: `https://kazva.bg`
        });

        setTopics(res.data.topics);
        setLoading(false);
    };

    useEffect(() => {
        setGlassPanelColor('black');
        setGlassPanelBackdropFilter(0, 1, 1);
        setTopicData(null);
        loadTopics();
    }, []);

    return (
        <div style={{ padding: '20px' }}>
            <Helmet>
                <title>Начало - Казва БГ</title>
                <link rel="canonical" href={`https://kazva.bg`} />
                <meta name="description" content={'Бъди чут със системата за обратна връзка на България - kazva.bg!'} />
            </Helmet>
            <StyledContentPanel style={{ marginBottom: '20px', backgroundColor: '#333',lineHeight: '1.3' }}>
                <TypingText text={t('home_message')} delay={20} />
            </StyledContentPanel>
            {!topics ? null : topics.map((topic: TopicCard, i: number) => 
                <TopicCardComponent key={i} darkMode topic={topic} onClick={() => { history.push(topic.slug) }} />
            )}
        </div>
    );
};
